import type { JSX } from 'react';
import { useMemo } from 'react';

import type { PrepaidDeps } from '@/features/prepaid';
import { MyWalletPage, PrepaidProvider, createPrepaidApi } from '@/features/prepaid';

import { clientFetcher } from './bp03';
import { useClientDeps } from './deps';

/**
 * BP-14 §6's one client row: `/me/wallet`.
 *
 * **A client never sells themselves anything.** All three capabilities are
 * `false`: a package bought at 2 a.m. without a conversation is a refund
 * request, which is why §2 puts selling out of the client app's scope
 * entirely. The screen reads, and that is all it can do.
 *
 * `outletId` is empty for the same reason — nothing here books a sale.
 */
export function useClientPrepaidDeps(): PrepaidDeps {
  const deps = useClientDeps();
  const fetcher = clientFetcher(deps.fetcher);
  const api = useMemo(() => createPrepaidApi(fetcher), [fetcher]);
  return { api, canDefine: false, canSell: false, canVoid: false, outletId: '' };
}

/** §6 client `/me/wallet`. */
export function MyWalletRoute(): JSX.Element {
  return (
    <PrepaidProvider deps={useClientPrepaidDeps()}>
      <MyWalletPage />
    </PrepaidProvider>
  );
}
